import React from 'react';
import { ActivityDay } from '../../types';

interface ActivityChartProps {
  activity: ActivityDay[];
}

const ActivityChart: React.FC<ActivityChartProps> = ({ activity }) => {
  const hasActivity = activity.some(a => a.count > 0);

  if (!hasActivity) {
    return <p className="text-gray-500 text-center py-4">No activity in the last 14 days yet.</p>;
  }

  const maxCount = Math.max(1, ...activity.map(a => a.count));

  return (
    <div className="flex items-end gap-1.5 md:gap-2 h-40">
      {activity.map(a => {
        const d = new Date(`${a.date}T00:00:00Z`);
        const label = d.toLocaleDateString(undefined, { weekday: 'short', timeZone: 'UTC' });
        const heightPct = a.count > 0 ? Math.max(8, Math.round((a.count / maxCount) * 100)) : 0;
        return (
          <div key={a.date} className="flex-1 flex flex-col items-center justify-end h-full group relative">
            <span className="text-xs font-semibold text-gray-500 mb-1 opacity-0 group-hover:opacity-100 transition-opacity">{a.count}</span>
            <div
              className={`w-full rounded-t-md transition-all duration-300 ${a.count > 0 ? 'bg-gradient-to-t from-blue-600 to-cyan-400' : 'bg-gray-100'}`}
              style={{ height: `${a.count > 0 ? heightPct : 4}%` }}
              title={`${a.count} lesson${a.count === 1 ? '' : 's'} on ${d.toLocaleDateString()}`}
            />
            <span className="text-[10px] text-gray-400 mt-1">{label[0]}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityChart;
